import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PricingSection() {
  return <section className="w-full px-6 py-20 bg-cream" data-id="element-86">
      <div className="max-w-reading mx-auto space-y-16" data-id="element-87">
        {/* Qualification */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-88">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-6 rounded-xl border-t-4 border-green-700/50 shadow-sm" data-id="element-89">
            <h3 className="text-xl font-serif text-brown mb-4" data-id="element-90">
              Es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-91">
              {['Tienes bebé 0–12 meses', 'Te sientes al límite y no quieres explotar', 'Tienes a alguien con quien repartir y quieres hacerlo sin drama'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-brown/80" data-id="element-92">
                  <Check className="w-4 h-4 text-green-700 mt-0.5 flex-shrink-0" data-id="element-93" />
                  <span data-id="element-94">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-6 rounded-xl border-t-4 border-red-400/50 shadow-sm" data-id="element-95">
            <h3 className="text-xl font-serif text-brown mb-4" data-id="element-96">
              No es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-97">
              {["Buscas una 'rutina perfecta' tipo influencer", 'Estás en una situación de violencia/control (ahí lo primero es seguridad)'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-brown/80" data-id="element-98">
                  <X className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0" data-id="element-99" />
                  <span data-id="element-100">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Price & CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} id="pricing" className="text-center bg-white p-10 rounded-2xl shadow-xl border border-ochre/20 relative overflow-hidden" data-id="element-101">
          <div className="absolute top-0 left-0 w-full h-2 bg-ochre" data-id="element-102"></div>

          <div className="inline-block bg-red-500 text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6 animate-pulse" data-id="element-103">
            🔥 -57% Oferta por tiempo limitado
          </div>

          <div className="mb-6" data-id="element-104">
            <div className="flex items-center justify-center gap-3 mb-1" data-id="element-105">
              <span className="text-2xl text-brown/40 line-through font-serif" data-id="element-106">
                US$17
              </span>
              <span className="bg-red-100 text-red-600 text-xs font-bold px-2 py-0.5 rounded" data-id="element-107">
                AHORRA US$9.61
              </span>
            </div>
            <span className="text-5xl md:text-6xl font-serif text-brown" data-id="element-108">
              US$7.39
            </span>
            <span className="text-brown/60 block mt-2 text-sm uppercase tracking-widest" data-id="element-109">
              (pago único)
            </span>
          </div>

          <p className="text-brown/80 mb-8 max-w-sm mx-auto" data-id="element-110">
            Porque esto no compite con un curso largo. <br data-id="element-111" />
            Compite con otra semana de aguantar en silencio.
          </p>

          <a href="https://pay.hotmart.com/S104422257M" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-flex items-center justify-center gap-2 bg-ochre hover:bg-ochre-hover text-white text-lg font-medium py-4 px-8 rounded-full w-full md:w-auto transition-all transform hover:scale-105 shadow-lg shadow-ochre/20 group" data-id="element-112">
            Quiero mi kit — US$7.39
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-113" />
          </a>
        </motion.div>
      </div>
    </section>;
}